import { defineStore } from 'pinia'

export default defineStore({
  id: 'reportPage',
  persist: true,
  state: () => {
    return {
      filters: {
        dateRange: [],
        customer: 'all',
        customerName: 'Tất cả',
        node: 'all',
        nodeName: 'Tất cả'
      }
    }
  },
  getters: {},
  actions: {
    clear: function () { },
    setFilters: function (payload: any) {
      Object.assign(this.filters, payload || {})
    }
  }
})
